import { BaseInterface } from './base.interface';

/** 红利活动 */
export interface BonusList {
  ctivityRules?: string | null;
  activityType: string;
  activityTypeName: string[];
  bonusActivitiesNo: string;
  bonusActivityName: string;
  bonusFixedUsdt: number;
  bonusMaxUsdt: number;
  index: number;
  isActive: boolean;
  isCurrentCryptoDepositBonus?: boolean;
  labels: string[];
  /** 0:不指定 1:固定金額 2:固定比例 */
  prizeAmountType: number;
  /**奖品类型，1:现金券,2:抵用金,3:后发现金券,4:实物,5:装备,6:Free Spin,7:SVIP体验券，99:未中奖 */
  prizeType: number;
  projectedCurrency: string;
  projectedIncome: number;
  projectedOrdNum: number;
  projectedTotalNum: number;
  rateVos: Array<{ minDepositUsdt: number; rate: number }>;
  releaseCardTypeCode: string;
  returnPercentage: number;
  grantTypeName: string;
  /** 免费旋转次数 */
  freeSpinTimes?: number | null;
  eventClaimLimit?: number; // 活动领取上限（分母）
  eventClaimedCount?: number; // 活动已领取次数（分子）
}

/** 非激活参数 */
export interface NoneInActivatedCards {
  casinoBonusList: Array<InactiveCardsAttri>;
  liveCasinoBonusList: Array<InactiveCardsAttri>;
}

export interface InactiveCardsAttri extends NoneActivatedAttri {
  isDeposit: boolean;
  minimumDeposit: number;
  /** 充值专用 CashBack 比率 */
  rate: number;
}

/** 激活非粘性 */
export interface NoneActivated {
  [key: string]: NoneActivatedAttri | null;
}

/** 卡券属性 */
export interface NoneActivatedAttri {
  code: string;
  category: string;
  currency: string;
  name: string;
  targetBetTurnover: number;
  currentBetTurnover: number;
  betMultiple: number;
  maxBetPerSpin: number;
  expires: number;
  /** 激活卡券余额, 当余额 小于等于0 时候，无法操作激活卡券 */
  // 若isFreeSpin == true 时，balance 为代表旋转（获得）奖金
  balance: number;
  /** 卡券金额 */
  // 若isFreeSpin == true amount 为代表旋转价值
  amount: number;
  /** 激活后 多天内过期 0 未永久 */
  durationDaysAfterActivation: number;
  /** 卡券 图片类型  Unknown:0, //未知 Turntable:1, //大转盘  NewUser:2, //新人模板Deposit:3, //首存送 Guess:4, //竞猜*/
  typeCode: string;
  isDeposit: boolean;
  /** 目标次数 */
  targetBetNum: number;
  /** 当前次数 */
  currentBetNum: number;
  /** 自定属性 */
  showIntro: boolean;
  isTargetBetDone: boolean;
  processed: number | string;
  leftToWallet: number;
  loading: boolean;
  submitLoading: boolean;
  intro: string;
  calc: string;
  /** 当前次数和剩余次数 */
  rates: string;
  isLocked: boolean;
  /** 进度框的位置 */
  isLeft: string;
  /** 非粘性 红利 活动编号 */
  tmpCode: string;
  /** 当前非粘性 是否符合 kyc */
  countryCheck: boolean | null;
  /** free spin 的图片 */
  freeSpinImage?: string;
  /**是否free spin */
  isFreeSpin: boolean;
  /** 厂商id */
  providerCatId?: string;
  /** 游戏id */
  gameId?: string;
  /** 游戏名称 */
  gameName?: string;
  /** 旋转总次数 */
  maxSpinNum?: number;
  /** 已旋转次数 */
  currentSpinNum?: number;
}

/** 非粘性总览 */
export interface NoneStickyOverview {
  cashableBonus: number;
  cashableBonusInfos: Array<{
    amount: number;
    currency: string;
  }>;
  lockedBonus: number;
  casinoBonus: number;
  liveCasinoBonus: number;
}

/** ts 组件接口类型 */
export interface OverviewData {
  [key: string]: {
    text: string;
    amount: number;
    currency: string;
    cashableBonusInfos?: Array<{
      amount: number;
      currency: string;
    }>;
    showToolTips?: boolean;
  };
}

/** 优惠券查询记录接口返回 */
export interface IExchangeInfo extends BaseInterface {
  total: number;
  list: Array<{
    exchangeCode: string;
    name: string;
    createTime: number;
  }>;
}

/**
 * 卡券类型 常量
 */
export enum GrandType {
  Cash = 'Cash',
  SVIP = 'SVIP',
  BWCash = 'BWCash',
  Coupon = 'Coupon',
}

/** 活动列表  */
export interface BonusInfo {
  bonusMoney: number;
  bonusCurrency: string;
  bonusUsdtMoney: string;
  rankMoney: number;
  rankNumber: number;
  uid: string;
  avatar: string;
  userName: string;
}
/** 当前所有排名 */
export interface Rank extends BaseInterface {
  total: 0;
  bonusInfo: Array<BonusInfo>;
  activitiesNo: string;
}

/** 竞赛活动列表和活动名称 */
export interface ContestActivities extends BaseInterface {
  title: ContestActivitiesItem[];
  bannerImage?: {
    language: string;
    mobile: string;
    web: string;
  };
}

/** 单个竞赛活动 */
export interface ContestActivitiesItem extends BaseInterface {
  title: string;
  endTime: number | string;
  nowTime: number;
  activitiesNo: string;
  period: string;
  text: string;
  icon: string;
  /** 0-有效流水  10-大赢家(总输赢) 11-大赢家(单笔最大盈利)  2-运气最好 */
  executeType: number;
}

/** 每日竞赛 表格头部 */
export interface ContestTableRow extends BaseInterface {
  executeType: number;
  titles: Array<Titles>;
}

/** 活动title */

export interface Titles extends BaseInterface {
  icon: string | null;
  text: string;
  toolTips?: string | null;
}

/** 我的排名 */
export interface MyRank extends BaseInterface {
  activitiesNo: string;
  endTime: number;
  nowTime: number;
  remainingTime: number;
  kycCheck: boolean;
  title: string;
  period: string;
  isClose: boolean;
  bonusInfo: {
    bonusCurrency: string;
    bonusMoney?: number;
    bonusUsdtMoney?: string | number;
    rankMoney: number;
    rankNumber: number | string;
    uid?: string;
  };
}

/** 活动列表请求参数 */
export interface ActivityInfoParams extends BaseInterface {
  equipment: string;
  /** 产品类型筛选，可多值；与活动设定的产品类型有任一重叠即符合。不带或带空 = 不筛选（未设定产品类型的活动在带筛选时一律隐藏） */
  productTypes?: string[];
}

/** 活动列表 */
export interface ActivityList extends BaseInterface {
  list: ActivityNavList[];
}

export interface ActivityNavList extends BaseInterface {
  labelCode: string;
  labelName: string;
  list: RespActivityDetail[];
}

/** 活动详情返回 */
export interface RespActivityDetail extends BaseInterface {
  /** 活动编号 */
  activitiesNo: string;
  /** 所属标签代码（如 limitdate、guessing） */
  labelCode: string;
  /** 所属标签名称 */
  labelName: string;
  /** 仅详情接口返回，列表接口无此字段 */
  activeObject?: string;
  activityImgUrl: string;
  bannerImgUrl: string;
  /** 活动内容 HTML，仅详情接口返回，列表接口无此字段 */
  content?: string;
  detailImgUrl: string;
  endTime: number;
  introduction: string;
  isEnroll: boolean;
  isJoin: boolean;
  startTime: number;
  title: string;
  sort: number;
  /** 产品类型（卡片角落标签用），未设定为 null */
  productTypes: ProductType[] | null;
  /** CTA 类型 */
  ctaType: CtaType;
  /** CTA 链接。依 equipment 自动回对应连结；ctaType 非 Url 或连结为空时为 null */
  ctaUrl: string | null;
  /** 订阅 ID（ctaType = OptIn 时点击订阅用），无订阅设定时为 null */
  subscriptionId: number | null;
  subscriptionStatus: SubscriptionStatus;
}

/** CTA 類型 */
export enum CtaType {
  /** 無 CTA（預設） */
  None = 'None',
  /** 点击订阅（使用 subscriptionId 走訂閱流程） */
  OptIn = 'OptIn',
  /** 跳转连结（使用 ctaUrl 導頁） */
  Url = 'Url',
}

/** 產品類型，複用 ProviderCategory，只開放以下 4 個值 */
export enum ProductType {
  /** 體育 */
  SportsBook = 'SportsBook',
  /** 電競 */
  Esports = 'Esports',
  /** 娛樂城 */
  LiveCasino = 'LiveCasino',
  /** 老虎機 */
  SlotGame = 'SlotGame',
}

/**
 * 卡券发放方式下拉列表
 */
export interface GrantTypeSelect extends BaseInterface {
  code: string;
  description: string;
}

/**
 * 钱包历史记录 红利 请求参数
 */
export interface BonusGrantParam extends BaseInterface {
  startTime: number;
  endTime: number;
  grantType: string;
  currency: string;
  pageIndex: number;
  pageSize: number;
}

/**
 * 红利历史记录返回数据
 */
export interface BonusGrantListData extends BaseInterface {
  grantTime: number;
  bonusOrderId: string;
  bonusNam?: string;
  currency: string;
  amount: number;
  grantType: string;
  grantName: string;
  vipLevel: number;
  statusName: string;
}

export interface ActivityDetail extends BaseInterface {
  bonusActivitiesNo: string;
  equipment: string;
}

/**
 * 卡券状态返回数据
 */
export interface BonusSelect extends BaseInterface {
  code: string;
  description: string;
}

/**
 * 卡券类型返回数据
 */
export interface BonusTypeList extends BaseInterface {
  grantType: string | null;
  title: string;
  total?: number;
  typeCode: string | null;
  newTypeCode: string;
}

/**
 * 用户卡券列表返回数据
 */
export interface BonusDetail extends BaseInterface {
  total: number;
  list: BonusDetailList[];
}

export interface BonusDetailList extends BaseInterface {
  activitiesNo: string;
  activityType: string;
  amount: number | string;
  balance: number;
  bonusRate: number;
  cardStatus: string;
  createdTime: number;
  currency: string;
  expiredTime: number;
  grantType: GrandTypes;
  id: number;
  introduction: string;
  isAccumulate: boolean;
  labels: any;
  maxBetAmount: number;
  maxBetRate: number;
  multiCurrency: any;
  receiveTime: number;
  title: string;
  typeCode: string;
  vipLevel: number;
  withdrawFlowMultiple: number;
  /** 用户排序后 返回对应值 未排序为0 */
  sort: number;
  /** 为 0 时 不限制 */
  minBetLimit: number;
  /** 如果是活动获得freespin，内容是按照活动的“活动规则”；如果是优惠券获得freespin，内容是按照“条款及条件 */
  description: string | null;
  /** 遊戲名稱 */
  gameName: string | null;
  /** provider id */
  gameProviderId: string | null;
  /** game id */
  gameId: string | null;
  /** game logo */
  gameLogoUrl: string | null;
  /** app game logo */
  gameAppLogoUrl: string | null;
  /** 免費旋轉次數 */
  spinNum: number;
  /** 派彩上限 */
  exchangeLimit: number;
  /** Bonus 錢包類型 */
  walletType: NewBonusWalletType;
}

/** 卡券赋予的类型 */
export type GrandTypes = 'Cash' | 'Coupon' | 'SVIP' | 'InKind' | 'Equip' | 'BWCash' | 'FreeSpin' | 'FreeChip';

/** Bonus 錢包類型 */
export enum NewBonusWalletType {
  CpDeposit = 'CpDeposit',
  BWCash = 'BWCash',
  FreeSpin = 'FreeSpin',
  FreeChip = 'FreeChip',
}

/** 获取卡券详情接口 */
export interface BonusDetailParams extends BaseInterface {
  pageIndex?: number;
  pageSize?: number;
  typeCode?: string;
  grantType?: string;
  status: string;
  ascSort: boolean;
  /** 是否返回 用户上一次排序 */
  userSort?: boolean;
  /** 是否使用 分页 */
  isByPage?: boolean;
}

/** 抵用金 排序参数 */
export interface BonusSortParam extends BaseInterface {
  id: string;
  sort: number;
}

/**
 * 用户卡券反水返回数据
 */
export interface BackwaterData extends BaseInterface {
  total: number;
  list: BackwaterDataList[];
}

export interface BackwaterDataList extends BaseInterface {
  amount: number;
  createdTime: number;
  currency: string;
  orderNum: string;
  cardStatus: string;
}

export interface BackwaterListParams extends BaseInterface {
  bonusId: number;
  pageIndex: number;
  pageSize: number;
}

export interface ReceiveBackwaterParams extends BaseInterface {
  bonusId: number;
  collectedCurrency?: string; //v2新增可以選擇兌換的幣種
  grantType?: string;
}

export interface BonusFlowParams extends BaseInterface {
  bonusId: number;
  pageIndex: number;
  pageSize: number;
}

export interface BonusCustomerApply extends BaseInterface {
  vipLevel: number;
  bonusActivitiesNo: string;
}

/**
 * LED请求返回数据
 * 多了configInfop分類 另外開
 */
export interface LaterResponseListData<T, K> extends BaseInterface {
  success: boolean;
  message: string;
  code: string;
  data: {
    total: number;
    list: T;
    configInfo: K;
  };
}
/**
 * LED解鎖彈窗 pageInfo
 */
export interface LaterPageInfo extends BaseInterface {
  orderNumber: string; //订单号
  createTime: number; //发放时间
  activitiesName: string; //活动号
  amount: number; //金额
  typeCode: string; //活动code
  activitiesNo: string; //红利活动编号
  activityType: string; //活动类型 Bonus:1,Vip:2,Exchange:3,
}
/**
 * LED解鎖彈窗configinfo
 */
export interface LaterConfigInfo extends BaseInterface {
  lockedAmount: number; //解锁金额，LED
  unlockedAmount: number; //未解锁金额，LED
  receiveAmount: number; // 已领取金额，LED
  minAmount: number; //可领取的最低金额 LED
  lockRatio: number; //解锁百分比，如果是20%，那么该值就是20
}
/**
 * 紅利陣列usdt from bonus/getbonusactivity
 */
export interface rateVosUsdt extends BaseInterface {
  minDepositUsdt: number; //最低存款金额usdt
  rate: number; //倍率 ex:10,前端显示110%
}
/**
 * 紅利陣列根據幣種 from bonus/currecnytorate
 */
export interface rateVos extends BaseInterface {
  minDeposit: number; //最低存款金额usdt
  rate: number; //倍率 ex:10,前端显示110%
  currency: string; //币种 ex:CNY
}

/** 兑换券 */
export interface ExchangeCard {
  exchangeCode: string;
  name: string;
  createTime: number;
}

/** 下拉页码 */
export interface IDropDown extends BaseInterface {
  key: string;
  value: number;
}

/** 非粘卡券状态更新 */
export interface SigalNonStickyStatus {
  action: 'NonStickyStatus';
  related: string;
  status: string;
  time: number;
  data: {
    Success: boolean;
  };
}

export interface CouponCodeParams {
  // 可为 0 兼容 欧洲
  amount?: number;
  couponCode: string;
  /** 当前存款货币 币种可为空*/
  currency?: string;
}

export interface CouponCodeExchangeResult extends BonusList {
  id: number;
  minDepositUsdt: number;
}

export interface DepositBonusInfo {
  bonusCode: string;
  minDepositUsdt: number;
  currencies: DepositBonusCurrency[];
}

export interface DepositBonusCurrency {
  currency: string;
  minDepositAmount: number;
}

export enum CardCenterPath {
  Coupon = 'coupon',
  Cash = 'cash',
  Bonus = 'bonus',
}

/**
 * 訂閱狀態
 */
export enum SubscriptionStatus {
  /** 未知 */
  Unknown = 'Unknown',
  /** 訂閱名單待開始 */
  Pending = 'Pending',
  /** 訂閱名單進行中（可訂閱） */
  Active = 'Active',
  /** 訂閱名單已停止 */
  Inactive = 'Inactive',
  /** 訂閱名單已過期 */
  Expired = 'Expired',
  /** 使用者已訂閱 */
  Subscribed = 'Subscribed',
}

/**
 * 會員訂閱返回結果
 */
export interface memberSubscribe {
  isSuccess: boolean;
  status: SubscriptionStatus;
}

/**
 * 已查看類型
 */
export enum SeenType {
  BonusUnclaimed = 'BonusUnclaimed',
  Activity = 'Activity',
}
